module.exports = __webpack_public_path__ + "static/screenshot-22113032ee5dfb4aeb722dc74408ef53.png";